import { Box, Grid } from '@mui/material';
import { 
	BooleanInput, 
	Create, 
	DateInput, 
	NumberInput, 
	ReferenceInput, 
	SelectInput, 
	SimpleForm, 
	TextInput 
} from 'react-admin';

const DatingEventCouponCreate = () => (
	<Create resource="dating-event-coupon">
		<SimpleForm>
			<Grid spacing={2} container>
				<Grid item sm={6}>
					<TextInput source="code" fullWidth label="קוד קופון" dir="ltr" required />
				</Grid>
				<Grid item sm={6}>
					<ReferenceInput source="eventId" reference="dating-events" label="אירוע דייטינג" required>
						<SelectInput optionText="title" optionValue="_id" />
					</ReferenceInput>
				</Grid>
				<Box width="100%" />
				<Grid item sm={6}>
					<BooleanInput source="isUsed" fullWidth label="שימוש" />
				</Grid>
			</Grid>
		</SimpleForm>
	</Create>
);

export default DatingEventCouponCreate;
